import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-regimen',
  templateUrl: './regimen.component.html',
  styleUrls: ['./regimen.component.scss']
})
export class RegimenComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
